<template>
  <el-dialog
    class="seq-dialog"
    title="选择单号"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="900px"
  >
    <el-form :model="form" :inline="true" size="small">
      <el-form-item label="订单状态：" prop="status">
        <el-select v-model="form.status" placeholder="请选择订单状态" @change="refresh">
          <el-option
            v-for="(item, index) in statusOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="下单时间：" class="date">
        <el-date-picker
          v-model="form.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="截止时间"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="refresh"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <el-table
      max-height="530"
      border
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="50" />
      <el-table-column label="订单号">
        <template slot-scope="scope">
          {{ scope.row.value.no }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="下单时间">
        <template slot-scope="scope">{{
          scope.row.value.createTime | rTime
        }}</template>
      </el-table-column>
      <el-table-column prop="value.orderStatusName" label="订单状态">
      </el-table-column>
    </el-table>
    <div class="page tr">
      <el-pagination
        layout="sizes, prev, pager, next"
        :page-size="pageSize"
        :current-page="page + 1"
        :total="total"
        @size-change="changeSizes"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { sequencingOrders } from "@/services/api.index";
export default {
  data() {
    return {
      visible: false,
      form: {
        status: "",
        date: ["", ""],
      },
      tableData: [],
      statusOptions: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "进行中",
          value: "ING",
        },
        {
          label: "已完成",
          value: "OK",
        },
      ],
      selectionList: [],
      total: 0,
      page: 0,
      pageSize: 10,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; // 如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
    };
  },
  methods: {
    refresh() {
      this.page = 0;
      this.getOrders();
    },
    getOrders() {
      const { page, pageSize } = this;
      let { date, status } = this.form;
      date = date || ["", ""];
      let endTime = ["", ""];
      const searchIds = this.baseMethods.getSearchId();
      sequencingOrders(
        page,
        pageSize,
        "",
        ...date,
        ...endTime,
        status,
        ...searchIds
      ).then((res) => {
        res.data.list.map((item) => {
          item.value.orderStatusName = this.baseMethods.orderStatus(
            item.userWebOrderStatus
          );
        });
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      });
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 翻页
    changePage(value) {
      this.page = value - 1;
      this.getOrders();
    },
    changeSizes(value) {
      this.pageSize = value;
      this.refresh();
    },
    open() {
      this.visible = true
      this.pageSize = 10;
      this.form = {
        status: "",
        date: ["", ""],
      }
      this.refresh();
    },
    handleClose() {
      this.visible = false
    },
    handleSubmit() {
      if (!this.selectionList.length)
        return this.$message.warning("请选择订单");
      this.handleClose();
      this.$emit(
        "update",
        this.selectionList.map((item) => item.value.no)
      );
    },
  },
};
</script>

<style scope lang="scss">
.page {
  padding: 10px 0;
}
.seq-dialog {
  margin-top: -5vw;
  .el-dialog__body {
    padding: 10px 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/tools/component/SeqOrderDialog.vue